import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import SalirIconDrop from "_+_Portal/assets/images/generico/SalirIconDrop";
import TurnoSinRecepcion from "_+_Portal/_-_Autocheckin/components/genericos/TurnoSinRecepcion/TurnoSinRecepcion";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsGetTurnosPacienteDelDiaQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import CardAguardar from "../../components/genericos/CardAguardar/CardAguardar";
import LayoutPasos from "../../components/genericos/LayoutPasos/LayoutPasos";
import { getLocalStorage } from "global/utils/safeJsonParse";

import {
  BtnColaVirtual,
  ContainerCardRecep,
  ContainerTurnosRecep,
  ContenidoPendiente,
} from "./localStyle";

const TurnosRecepcionadosQR = ({ turnoActual, setLoading }) => {
  const {
    turnosRecepcionadosState,
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
    pasoDispatch,
    turnosAutoCheckInDispatch,
  } = useContext(AutocheckContext);

  const { modalDispatch } = useContext(GlobalContext);
  const config = getLocalStorage("config", {});
  let opcFilaVirtual = config?.opcFilaVirtual;

  // -------------------------  constantes ----------------------------

  const listaTurnos = turnosRecepcionadosState.turnosRecepcionados?.data ?? [];

  // Detectamos turnos pendientes con doble vía:
  // 1) Filtrando la lista del día por flag `presente`.
  // 2) Como fallback, comparando contra la lista de recepcionados (si en la del
  //    día hay más turnos que recepcionados, hay pendientes).
  // Esto cubre casos donde un filtro de la lista del día (idProtocolo/ausente)
  // excluye injustamente un turno pendiente válido.
  const turnosDelDia = turnosAutoCheckInState.turnosAutoCheckIn?.data ?? [];
  const turnosPendientes = turnosDelDia.filter(
    (t) => t && !t.presente && !t.ausente && !t.idProtocolo,
  );
  const hayPendientes =
    turnosPendientes.length > 0 ||
    turnosDelDia.length > listaTurnos.length;

  console.log("[CheckinQR] TurnosRecepcionadosQR diag", {
    turnosDelDiaCount: turnosDelDia.length,
    turnosDelDia: turnosDelDia.map((t) => ({
      idturno: t?.idturno,
      especialidad: t?.especialidad,
      presente: t?.presente,
      ausente: t?.ausente,
      idProtocolo: t?.idProtocolo,
      checkin: t?.checkin,
      idCentro: t?.idCentro,
    })),
    turnosPendientesCount: turnosPendientes.length,
    hayPendientes,
    listaTurnosCount: listaTurnos.length,
  });
  // -------------------------  constantes ----------------------------

  const [len, setLen] = useState(0);
  const [select, setSelect] = useState(listaTurnos.length === 1 ? 0 : false);

  const handleClick = () => {
    setTurnosSeleccionado(listaTurnos[0])(turnosSeleccionadosDispatch);
    setPaso("DemoraPaciente")(pasoDispatch);
  };
  const VerTurnosRecepcionados = () => {
    setSelect(false);
    setLen(0);
  };

  const recepcionarme = () => {
    const nexsStep = (isCorrect, data) => {
      setPaso("TurnosDelDia")(pasoDispatch);
    };
    setLoading("Cargando turnos del día...");
    wsGetTurnosPacienteDelDiaQr(nexsStep)(turnosAutoCheckInDispatch);
    // setPaso("TurnosDelDia")(pasoDispatch);
    hideModal()(modalDispatch);
  };

  const salirSinRecepcion = () => {
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (hayPendientes) {
      showModal(
        <TurnoSinRecepcion
          title={"Turnos sin recepcionar"}
          desc="Cuenta con otros turnos para el día de hoy sin recepcionar."
          textBtnOne={"Salir"}
          textBtnTwo="Recepcionarme"
          handleClick={{
            btnTwoClick: recepcionarme,
            btnOneClick: salirSinRecepcion,
          }}
        />
      )(modalDispatch);
    }
  }, []);

  return (
    <LayoutPasos volverTo={"/autocheckin"} title={"Turnos recepcionados"}>
      <ContainerTurnosRecep
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        {opcFilaVirtual && (
          <BtnColaVirtual className="rb18b" onClick={handleClick}>
            Ver cola virtual
          </BtnColaVirtual>
        )}

        <ContainerCardRecep>
          {listaTurnos.map((element, key) => {
            if (!select && len !== 1)
              return (
                <CardAguardar
                  horaTurno={element.hora}
                  nombreTurno={element.especialidad}
                  sedeTurno={element.centro}
                  pisoTurno={element.piso}
                  flgSoloConsulta={element.flgSoloConsulta}
                  medico={element.medico}
                  consultorioTurno={
                    !element?.consultorio ? "" : element?.consultorio
                  }
                  btnDisable={len === 1}
                  handleClick={() => {}}
                  key={key}
                  index={key}
                />
              );
            if (select === key) {
              return (
                <CardAguardar
                  horaTurno={element.hora}
                  nombreTurno={element.especialidad}
                  sedeTurno={element.centro}
                  pisoTurno={element.piso}
                  flgSoloConsulta={element.flgSoloConsulta}
                  medico={element.medico}
                  consultorioTurno={
                    !element?.consultorio ? "" : element?.consultorio
                  }
                  btnDisable={len === 1}
                  key={key}
                  handleClick={() => {}}
                />
              );
            }
          })}
          {len === 1 && (
            <>
              <button className="turnos" onClick={VerTurnosRecepcionados}>
                Ver Turnos recepcionados
              </button>
              <div
                className="message"
                dangerouslySetInnerHTML={{
                  __html: `Vemos que ya se anunció. <br/>
                          Le pedimos que aguarde a ser llamado.`,
                }}
              />
            </>
          )}
        </ContainerCardRecep>

        {len === 0 && hayPendientes && (
          <ContenidoPendiente>
            <span>{"Tiene turnos para recepcionar."}</span>
            <button className="turnos" onClick={recepcionarme}>
              <SalirIconDrop color={"var(--color-white)"} />
              Ver turnos pendientes
            </button>
          </ContenidoPendiente>
        )}
      </ContainerTurnosRecep>
    </LayoutPasos>
  );
};

export default TurnosRecepcionadosQR;
